const moment = require('moment-timezone');
export const convertDate = (date) => {
    let easternDate = moment(date).tz("America/New_York").format('MM/DD/YYYY @ h:mm A z');
    return easternDate;
}